
/**
 * Play notification sound
 */
export const playNotificationSound = async (): Promise<void> => {
  try {
    const audio = new Audio('/notification-sound.mp3');
    await audio.play();
  } catch (error) {
    console.error('Failed to play notification sound:', error);
  }
};

/**
 * Play backup sound (alias for notification sound)
 */
export const playBackupSound = async (): Promise<void> => {
  return playNotificationSound();
};
